import { CityCreateForm, CityCreateFormErrors, CityCreateFormErrorsSchema } from '@/types/city/city-create-form.type.ts';

export type CityUpdateForm = CityCreateForm;

export type CityUpdateFormErrors = CityCreateFormErrors;

export const CityUpdateFormErrorsSchema = CityCreateFormErrorsSchema;
